





























































































































































































































































































































import { Component, Prop } from "vue-property-decorator";
import { VueEditor } from "vue2-editor";
import { mixins } from "vue-class-component";
import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";
import { required, numeric, minValue } from "vuelidate/lib/validators";
import { Validate } from "vuelidate-property-decorators";
import { i18n } from "@/resources/locales";
@Component({
  name: "exam-generator-component",
  components: {
    VueEditor,
  },
})
export default class examGeneratorComponent extends mixins(NotificationEvent) {
  jsonEducation = require("../../../../assets/education/education.json");
  jsonEducationParse = null;
  @Prop() back;
  @Validate({ required })
  educationLaw = "";
  @Validate({ required })
  course = "";
  @Validate({ required })
  subject = "";
  @Validate({ required, numeric, minValue: minValue(1) })
  questions = 0;
  @Validate({ required })
  language = "";
  educationalProgram = "";
  content = "";
  additionalComments = "";
  untitledDocument = "";
  loading = false;
  examId = null;
  jsonData = "";
  educationLawArray = [];
  coursesArray = [];
  subjectArray = [];
  mounted(): void {
    this.jsonEducationParse = JSON.parse(JSON.stringify(this.jsonEducation));
    this.educationLawArray = this.jsonEducationParse.laws;
  }
  destroyed() {
    const tooltip = document.getElementsByClassName("vs-tooltip");
    if (tooltip)
      while (tooltip.length > 0) {
        tooltip[0].parentNode.removeChild(tooltip[0]);
      }
  }
  selectCourse(name: string) {
    this.coursesArray = [];
    this.jsonEducationParse.laws.forEach((element) => {
      if (element.name == name) this.coursesArray = element.courses;
    });
  }
  selectSubject(name: string) {
    this.subjectArray = [];
    this.subject = "";
    this.coursesArray.forEach((element) => {
      if (element.name == name) this.subjectArray = element.subjects;
    });
  }
  selectCompetencies(name: string) {
    this.educationalProgram = "";
    this.subjectArray.forEach((element) => {
      if (element.subject == name)
        this.educationalProgram = element.competencies + "\n" + element.content;
    });
  }
  async createExam() {
    if (this.$v.$invalid) {
      this.$v.educationLaw.$touch();
      this.$v.course.$touch();
      this.$v.subject.$touch();
      this.$v.language.$touch();
      this.$v.questions.$touch();
      return;
    }
    this.deleteContet();
    this.loading = true;
    await this.$store.dispatch("HawkingsStore/createExamAction", {
      data: {
        educationalProgram: this.educationLaw,
        grade: this.course,
        subject: this.subject,
        subjectProgram: this.educationalProgram,
        questionNumber: Math.floor(this.questions),
        comments: this.additionalComments,
        language: this.language,
      },
      callback: (response) => {
        this.untitledDocument = response.data.title;
        this.examId = response.data.id;
        this.generate();
      },
      callbackError: (error) => {
        this.loading = false;
        console.log("TTT createExam KO ", error);
      },
    });
  }
  async generate() {
    await this.$store.dispatch("HawkingsStore/sendExamGeneratorAction", {
      id: this.examId,
      callback: (response) => {
        const reader = response.body.getReader();
        const read = async () => {
          const { done, value } = await reader.read();
          if (done) {
            this.loading = false;
            return;
          }
          let message = new TextDecoder("utf-8").decode(value);
          const lines = message.split("\n\n");

          const parsedLines = lines
            .map((line) => line.replace(/^data: /, "").trim())
            .filter((line) => line !== "" && line !== "[DONE]")
            .map((line) => {
              try {
                return JSON.parse(line);
              } catch (ex) {
                console.log("ERROR ", line);
              }
              return "";
            });

          for (const parsedLine of parsedLines) {
            if (!parsedLine) continue;
            const { content } = parsedLine;
            if (content === undefined) continue;
            const doc = new DOMParser().parseFromString(
              this.content + content,
              "text/html"
            );
            this.content = doc.documentElement.textContent;
          }

          read();
        };

        read();
      },
      callbackError: (error) => {
        this.loading = false;
        console.log("TTT generate KO ", error);
      },
    });
  }
  async downloadExam() {
    if (this.examId == null) return;
    await this.$store.dispatch("HawkingsStore/downloadExamAction", {
      id: this.examId,
      title: this.untitledDocument,
      callback: (response) => {},
      callbackError: (error) => {
        console.log("TTT downloadExam KO ", error);
      },
    });
  }
  deleteContet() {
    this.content = "";
    this.untitledDocument = "";
    this.examId = null;
  }
  copy(): void {
    if (this.content.length <= 0) return;
    const content = document.getElementById("content");
    const cb = navigator.clipboard;
    cb.writeText(content.innerText).then(() =>
      this.onDefault("", this.$i18n.t("hawkings.examCopiedClipboard"))
    );
  }
  close() {
    this.$store.dispatch("SystemStore/setEducationToolModalAction", false);
  }
  clearForm() {
    this.educationLaw = "";
    this.course = "";
    this.subject = "";
    this.questions = 0;
    this.language = "";
    this.educationalProgram = "";
    this.additionalComments = "";
  }
  async loadExample() {
    await this.clearForm();
    let law =
      this.educationLawArray[
        Math.floor(Math.random() * this.educationLawArray.length)
      ];
    this.educationLaw = law.name;
    let couse = await law.courses[
      Math.floor(Math.random() * law.courses.length)
    ];
    this.selectCourse(law.name);
    this.course = couse.name;
    let subjets = await couse.subjects[
      Math.floor(Math.random() * couse.subjects.length)
    ];
    this.selectSubject(couse.name);
    setTimeout(() => {
      this.subject = subjets.subject;
    }, 200);
    this.educationalProgram = subjets.competencies + "\n" + subjets.content;
    this.questions = Math.floor(Math.random() * 5) + 1;
    this.language = i18n.locale == "es" ? "es_ES" : "en_US";
  }
}
